var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-button', {
    staticStyle: {
      "padding": "4px"
    },
    attrs: {
      "variant": "flat-info",
      "disabled": _vm.disabledCopy
    },
    on: {
      "click": _vm.onClickCopy
    }
  }, [_c('feather-icon', {
    staticClass: "cursor-pointer",
    attrs: {
      "icon": "CopyIcon",
      "size": "16"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }